/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { createSlice } from "@reduxjs/toolkit";

const assetliabilitySlice = createSlice({
  //REFERENCE NAME OF THIS DATA SLICE
  name: "assetliability",

  initialState: {
    //CASH ASSETS
    savings: "0.00",
    fixedDeposit: "0.00",
    otherCashDesc: "",
    otherCashAmount: "0.00",
    totalCashAsset: "0.00",

    //PERSSONAL USE ASSETS
    residencePropertyAmt: "0.00",
    motorVehiclesAmt: "0.00",
    otherPersonalAssetsDesc: "",
    otherPersonalAssetsAmt: "0.00",
    totalPersonalUseAsset: "0.00",

    //INVESTMENT ASSETS
    unitTrustAmt: "0.00",
    stocksAmt: "0.00",
    bondsAmt: "0.00",
    ilpAmt: "0.00",
    businessInterestAmt: "0.00",
    insuranceEndowmentAmt: "0.00",
    cpfOriginalAccountAmt: "0.00",
    cpfSavingsAccountAmt: "0.00",
    cpfMedisaveAmt: "0.00",
    srsAmt: "0.00",

    investmentPropertyAmt1: "0.00",
    investmentPropertyAmt2: "0.00",

    otherInvestmentDesc1: "",
    otherInvestmentAmt1: "0.00",
    otherInvestmentDesc2: "",
    otherInvestmentAmt2: "0.00",

    totalInvestmentAsset: "0.00",

    //LIABILLITIES - SHORT TERM
    stlCreditCardAmount: "0.00",
    stlBankOverdraftAmount: "0.00",
    stlOutstandingTaxAmount: "0.00",
    stlOtherDesc1: "",
    stlOtherDesc2: "",
    stlOtherDesc3: "",
    stlOtherAmt1: "0.00",
    stlOtherAmt2: "0.00",
    stlOtherAmt3: "0.00",
    totalShortTermLiability: "0.00",

    //LIABILLITIES - LONG TERM
    ltlResMortgageAmount: "0.00",
    ltlInvMortgageAmount: "0.00",
    ltlCarLoanAmount: "0.00",
    ltlOtherDesc1: "",
    ltlOtherDesc2: "",
    ltlOtherDesc3: "",
    ltlOtherAmt1: "0.00",
    ltlOtherAmt2: "0.00",
    ltlOtherAmt3: "0.00",
    totalLongTermLiability: "0.00",

    //SUMMARY
    totalassets: "0.00",
    totalliabilities: "0.00",
    totalnetworth: "0.00",

    //DECLARATION
    isNetworthDisclosed: "",
    haveNetworthImpact: "",
    networthImpactDesc: "",
  },

  reducers: {
    updateCashAsset: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "savings":
          state.savings = payload;
          break;

        case "fixedDeposit":
          state.fixedDeposit = payload;
          break;

        case "otherCashDesc":
          state.otherCashDesc = payload;
          break;

        case "otherCashAmount":
          state.otherCashAmount = payload;
          break;

        case "totalCashAsset":
          state.totalCashAsset = payload;
          break;

        default:
          break;
      }
    },

    updatePersonalUseAsset: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "residencePropertyAmt":
          state.residencePropertyAmt = payload;
          break;

        case "motorVehiclesAmt":
          state.motorVehiclesAmt = payload;
          break;

        case "otherPersonalAssetsDesc":
          state.otherPersonalAssetsDesc = payload;
          break;

        case "otherPersonalAssetsAmt":
          state.otherPersonalAssetsAmt = payload;
          break;

        case "totalPersonalUseAsset":
          state.totalPersonalUseAsset = payload;
          break;

        default:
          break;
      }
    },

    updateInvestmentAsset: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "unitTrustAmt":
          state.unitTrustAmt = payload;
          break;

        case "stocksAmt":
          state.stocksAmt = payload;
          break;

        case "bondsAmt":
          state.bondsAmt = payload;
          break;

        case "ilpAmt":
          state.ilpAmt = payload;
          break;

        case "businessInterestAmt":
          state.businessInterestAmt = payload;
          break;

        case "insuranceEndowmentAmt":
          state.insuranceEndowmentAmt = payload;
          break;

        case "cpfOriginalAccountAmt":
          state.cpfOriginalAccountAmt = payload;
          break;

        case "cpfSavingsAccountAmt":
          state.cpfSavingsAccountAmt = payload;
          break;

        case "cpfMedisaveAmt":
          state.cpfMedisaveAmt = payload;
          break;

        case "srsAmt":
          state.srsAmt = payload;
          break;

        case "investmentPropertyAmt1":
          state.investmentPropertyAmt1 = payload;
          break;

        case "investmentPropertyAmt2":
          state.investmentPropertyAmt2 = payload;
          break;

        case "otherInvestmentDesc1":
          state.otherInvestmentDesc1 = payload;
          break;

        case "otherInvestmentAmt1":
          state.otherInvestmentAmt1 = payload;
          break;

        case "otherInvestmentDesc2":
          state.otherInvestmentDesc2 = payload;
          break;

        case "otherInvestmentAmt2":
          state.otherInvestmentAmt2 = payload;
          break;

        case "totalInvestmentAsset":
          state.totalInvestmentAsset = payload;
          break;

        default:
          break;
      }
    },

    updateShortTermLiabilities: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "stlCreditCardAmount":
          state.stlCreditCardAmount = payload;
          break;

        case "stlBankOverdraftAmount":
          state.stlBankOverdraftAmount = payload;
          break;

        case "stlOutstandingTaxAmount":
          state.stlOutstandingTaxAmount = payload;
          break;

        case "stlOtherDesc1":
          state.stlOtherDesc1 = payload;
          break;

        case "stlOtherDesc2":
          state.stlOtherDesc2 = payload;
          break;

        case "stlOtherDesc3":
          state.stlOtherDesc3 = payload;
          break;

        case "stlOtherAmt1":
          state.stlOtherAmt1 = payload;
          break;

        case "stlOtherAmt2":
          state.stlOtherAmt2 = payload;
          break;

        case "stlOtherAmt3":
          state.stlOtherAmt3 = payload;
          break;

        case "totalShortTermLiability":
          state.totalShortTermLiability = payload;
          break;

        default:
          break;
      }
    },

    updateLongTermLiabilities: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "ltlResMortgageAmount":
          state.ltlResMortgageAmount = payload;
          break;

        case "ltlInvMortgageAmount":
          state.ltlInvMortgageAmount = payload;
          break;

        case "ltlCarLoanAmount":
          state.ltlCarLoanAmount = payload;
          break;

        case "ltlOtherDesc1":
          state.ltlOtherDesc1 = payload;
          break;

        case "ltlOtherDesc2":
          state.ltlOtherDesc2 = payload;
          break;

        case "ltlOtherDesc3":
          state.ltlOtherDesc3 = payload;
          break;

        case "ltlOtherAmt1":
          state.ltlOtherAmt1 = payload;
          break;

        case "ltlOtherAmt2":
          state.ltlOtherAmt2 = payload;
          break;

        case "ltlOtherAmt3":
          state.ltlOtherAmt3 = payload;
          break;

        case "totalLongTermLiability":
          state.totalLongTermLiability = payload;
          break;

        default:
          break;
      }
    },

    updateSummary: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "totalassets":
          state.totalassets = payload;
          break;

        case "totalliabilities":
          state.totalliabilities = payload;
          break;

        case "totalnetworth":
          state.totalnetworth = payload;
          break;

        case "isNetworthDisclosed":
          state.isNetworthDisclosed = payload;
          break;

        case "haveNetworthImpact":
          state.haveNetworthImpact = payload;
          break;

        case "networthImpactDesc":
          state.networthImpactDesc = payload;
          break;

        default:
          break;
      }
    },
  },
});

//Action creators are generated for each case reducer function
//This declares action that can be acted on this slice of data
export const {
  updateCashAsset,
  updatePersonalUseAsset,
  updateInvestmentAsset,
  updateShortTermLiabilities,
  updateLongTermLiabilities,
  updateSummary,
} = assetliabilitySlice.actions;

export default assetliabilitySlice.reducer;
